export default {"src":"/_next/static/media/three-quarter-star.06e226c7.svg","height":14,"width":17,"blurWidth":0,"blurHeight":0};